import * as TabsPrimitive from '@radix-ui/react-tabs'
import { cn } from '@/src/components/core/lib/utils'

function Tabs({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Root>) {
  return <TabsPrimitive.Root className={className} {...props} />
}

function TabsList({
  tabCount,
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.List> & {
  tabCount: number
}) {
  return (
    <div className={cn('rounded-full bg-gray-200 p-1', className)}>
      <TabsPrimitive.List
        className={cn(
          'relative grid auto-cols-fr grid-flow-col',
          "after:pointer-events-none after:absolute after:inset-0 after:w-[calc(100%/var(--count))] after:translate-x-[calc(var(--active)*100%)] after:rounded-full after:bg-white after:shadow-sm after:transition-transform after:duration-200 after:content-['']",
          "has-[>:nth-child(1)[data-state='active']]:[--active:0] has-[>:nth-child(2)[data-state='active']]:[--active:1] has-[>:nth-child(3)[data-state='active']]:[--active:2] has-[>:nth-child(4)[data-state='active']]:[--active:3] has-[>:nth-child(5)[data-state='active']]:[--active:4]"
        )}
        style={
          {
            '--count': tabCount,
          } as React.CSSProperties
        }
        {...props}
      />
    </div>
  )
}

function TabsTrigger({
  className,
  ...props
}: React.ComponentProps<typeof TabsPrimitive.Trigger>) {
  return (
    <TabsPrimitive.Trigger
      className={cn(
        'z-10 rounded-full px-4 py-2 text-sm whitespace-nowrap md:text-base',
        className
      )}
      {...props}
    />
  )
}

function TabsContent(
  props: React.ComponentProps<typeof TabsPrimitive.Content>
) {
  return <TabsPrimitive.Content {...props} />
}

export { Tabs, TabsList, TabsTrigger, TabsContent }
